import notificationTypes from '../../config/notificationTypes'

import getLabels from '../getLabels'
import generateUniqueId from '../generateUniqueId'
import buildCustomNotification from './buildCustomNotification'

const errorCode = 'error_no_valid_infant_date_of_birth'
const fieldName = 'DateOfBirth'

export default (passengerId: string) =>
  buildCustomNotification({
    id: generateUniqueId(),
    type: notificationTypes.warning,
    message: getLabels(errorCode),
    code: `[${errorCode}]`,
    isGlobal: false,
    passengerId,
    isInfant: true,
    fieldName,
  })
